// TODO: Fix eslint errors.
/* eslint-disable */
import { useIntl } from 'react-intl';
import textTransform from 'textTransform';

function CustomDateFormat(dateString, customDateFormat = '') {
  let format = process.env.REACT_APP_DATE_FORMAT;
  if (dateString.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/gm)) {
    dateString = `${dateString} 12:00:00`;
  }
  const date = new Date(`${dateString}`.replace(' ', 'T'));
  const nth = function (d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  const intl = useIntl();
  const lang = intl && intl.locale || null;

  if (process.env.REACT_APP_COUNTRY === 'ch' && lang === 'de') {
    format = 'd. M Y';
  } else if (process.env.REACT_APP_COUNTRY === 'ca' && lang === 'en') {
    format = 'northAmericanDate';
  } else if (process.env.REACT_APP_COUNTRY === 'gr') {
    format = 'd M Y';
  } else if (customDateFormat) {
    format = customDateFormat;
  }

  let formattedString = '';
  switch (format) {
    case 'y.m.d':
      formattedString = `${date.getFullYear()}\.${`${date.getMonth() + 1}`.padStart(2, 0)}\.${`${date.getDate()}`.padStart(2, 0)}`;
      break;
    case 'd M Y':
      const resultString = `${date.getDate()} ${intl.formatMessage({ id: `Date.Month${date.getMonth()}` })} ${date.getFullYear()}`;
      formattedString = process.env.REACT_APP_COUNTRY !== 'ca' ? resultString : resultString.toLowerCase();
      break;
    case 'j/m/Y':
      formattedString = `${date.getDate()}/${`${date.getMonth() + 1}`.padStart(2, 0)}/${date.getFullYear()}`;
      break;
    case 'job-board':
      const day = intl.formatMessage({ id: `Date.Day${date.getDay()}` });
      const month = intl.formatMessage({ id: `Date.Month${date.getMonth()}` });
      const of = intl.formatMessage({ id: 'Date.Of' });
      formattedString = `${day}, ${date.getDate()} ${of} ${month} ${of} ${date.getFullYear()}`;
      break;
    case 'd. M Y':
      formattedString = `${date.getDate()}. ${intl.formatMessage({ id: `Date.Month${date.getMonth()}` })} ${date.getFullYear()}`;
      break;
    case 'M/d/Y':
      formattedString = `${`${date.getMonth() + 1}`}/${date.getDate()}/${date.getFullYear()}`;
      break;
    case 'isoDateTime':
      formattedString = date.toISOString();
      break;
    case 'northAmericanDate':
      const dayFormatted = date.getDate();
      formattedString = `${intl.formatMessage({ id: `Date.Month${date.getMonth()}` })} ${dayFormatted}${nth(dayFormatted)}, ${date.getFullYear()}`;
      break;
    default:
      formattedString = `${date.getDate()} ${intl.formatMessage({ id: `Date.Month${date.getMonth()}` })} ${date.getFullYear()}`;
      break;
  }
  return textTransform(formattedString);
}

// Calculate days difference between two dates
function toDays(startDate, endDate) {
  const firstDate = new Date(startDate);
  const secondDate = new Date(endDate);

  const timeDiff = Math.abs(secondDate.getTime() - firstDate.getTime());
  return Math.round(timeDiff / (1000 * 3600 * 24));
}

function overrideIsoDateString() {
  // Override date prototype to format in 2021-02-22T10:08:07+02:00
  // instead of default ISO which is 2021-02-22T08:08:07.000Z
  Date.prototype.toIsoString = function () {
    const tzo = -this.getTimezoneOffset();
    const dif = tzo >= 0 ? '+' : '-';
    const pad = function (num) {
      const norm = Math.floor(Math.abs(num));
      return (norm < 10 ? '0' : '') + norm;
    };
    return `${this.getFullYear()
    }-${pad(this.getMonth() + 1)
    }-${pad(this.getDate())
    }T${pad(this.getHours())
    }:${pad(this.getMinutes())
    }:${pad(this.getSeconds())
    }${dif}${pad(tzo / 60)
    }:${pad(tzo % 60)}`;
  };
}

export { CustomDateFormat, toDays, overrideIsoDateString };
